import { render, staticRenderFns } from "./SweetAlertComponent.vue?vue&type=template&id=a08dd76c&"
import script from "./SweetAlertComponent.vue?vue&type=script&lang=js&"
export * from "./SweetAlertComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports